import { useEffect, useRef } from 'react';
import { getSocket } from '../utils/socket/socket.instance';
import { SOCKET_EVENTS } from '../utils/constants';

export const useChatRoom = chatId => {
  const prevChatIdRef = useRef(null);

  useEffect(() => {
    const socket = getSocket();
    if (!socket || !chatId) return;

    const joinRoom = () => {
      socket.emit(SOCKET_EVENTS.SWITCH_ROOM, {
        userInfluencerId: chatId,
      });
    };

    if (socket.connected) {
      joinRoom();
    }

    socket.on(SOCKET_EVENTS.CONNECTED, joinRoom);

    prevChatIdRef.current = chatId;

    return () => {
      socket.off(SOCKET_EVENTS.CONNECTED, joinRoom);
    };
  }, [chatId]);
};
